import React from "react";
import { motion } from "framer-motion";
import { ArrowDownIcon, ArrowRightIcon, FingerprintIcon, LayoutGridIcon, SparklesIcon, UsersIcon, ZapIcon, BoxIcon } from "lucide-react";
import { useLanguage } from "../LanguageContext";
import { sectorsHero as c } from "../../data/sectorsPage";
import { Bi } from "../../data/sectors";
const EASE = [0.23, 1, 0.32, 1] as const;
const FLOW_ICONS: Record<(typeof c.flow)[number]['key'], BoxIcon> = {
  people: UsersIcon,
  identity: FingerprintIcon,
  services: LayoutGridIcon,
  atna: SparklesIcon,
  actions: ZapIcon
};
export function SectorsHero() {
  const {
    lang
  } = useLanguage();
  const pick = (b: Bi) => lang === 'FR' ? b.fr : b.en;
  return <section className="relative overflow-hidden bg-white px-6 pt-16 lg:pt-24 pb-20 lg:pb-24" aria-labelledby="sectors-hero-title" data-id="element-6653" data-mp="3c7hrcm1iif9a">
      <div className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[420px] rounded-full bg-[#F1F0FD] opacity-70 blur-[140px]" aria-hidden="true" data-id="element-6654" data-mp="1wqh9b9mm82sw" />
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: EASE
    }} className="relative max-w-[1280px] mx-auto" data-id="element-6655" data-mp="9t4m8ndpb21h">
        <p className="font-sans text-[13px] font-medium tracking-[0.3em] uppercase text-[#4F46E5]" data-id="element-6656" data-mp="ivdsh11xs992">{pick(c.eyebrow)}</p>
        <h1 id="sectors-hero-title" className="font-serif text-[2.3rem] sm:text-[3rem] lg:text-[3.5rem] leading-[1.04] tracking-tight mt-5" data-id="element-6657" data-mp="erplajh7vfoc">
          {c.headline.map(l => <span key={l.text.fr} className={`block lg:whitespace-nowrap ${l.accent ? 'text-[#4F46E5]' : 'text-[#121A3A]'}`} data-id="element-6658" data-mp="nsnrn8f4nza3">
              {pick(l.text)}
            </span>)}
        </h1>
        <p className="mt-6 max-w-[640px] font-sans text-[16px] md:text-[17px] text-[#4A5268] leading-relaxed" data-id="element-6659" data-mp="xiyyb2q74mko">{pick(c.body)}</p>

        <ol className="mt-14 lg:mt-16 flex flex-col md:flex-row md:items-center gap-2 md:gap-0" aria-label={lang === 'FR' ? 'Modèle d’écosystème' : 'Ecosystem model'} data-id="element-6660" data-mp="1bk1gv5hzfequ">
          {c.flow.map((f, i) => {
          const Icon = FLOW_ICONS[f.key];
          const atna = f.key === 'atna';
          return <li key={f.key} className="flex flex-col md:flex-row items-start md:items-center md:flex-1 min-w-0" data-id="element-6661" data-mp="96n6koxi7khk" data-mpi={i}>
                <div className={`flex items-center gap-3 rounded-full pl-2 pr-5 py-2 border ${atna ? 'bg-[#4F46E5] border-[#4F46E5] text-white' : 'bg-white border-[#E7E6F3] text-[#121A3A]'}`} data-id="element-6662" data-mp="d5vxlm15t49f">
                  <span className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${atna ? 'bg-white/15' : 'bg-[#F1F0FD]'}`} data-id="element-6663" data-mp="mwqlsvxyudxi">
                    <Icon className={`w-4 h-4 ${atna ? 'text-white' : 'text-[#4F46E5]'}`} strokeWidth={1.7} aria-hidden="true" data-id="element-6664" data-mp="wvg4gqxos2et" />
                  </span>
                  <span className="font-sans text-[13px] font-semibold tracking-[0.08em] uppercase whitespace-nowrap" data-id="element-6665" data-mp="10whwont6re7a">{pick(f.label)}</span>
                </div>
                {i < c.flow.length - 1 && <>
                    <span className="hidden md:flex flex-1 items-center px-3 min-w-[24px]" aria-hidden="true" data-id="element-6666" data-mp="32oo8qey0ydm0">
                      <span className="flex-1 h-px bg-[#D9D7F4]" data-id="element-6667" data-mp="2v6yhyiynd21w" />
                      <ArrowRightIcon className="w-3.5 h-3.5 text-[#8B85F0] -ml-1" strokeWidth={1.8} data-id="element-6668" data-mp="2qddh8j5o5tz0" />
                    </span>
                    <ArrowDownIcon className="md:hidden w-3.5 h-3.5 text-[#8B85F0] ml-6 my-1" strokeWidth={1.8} aria-hidden="true" data-id="element-6669" data-mp="2lczjpv1p22f8" />
                  </>}
              </li>;
        })}
        </ol>

        <p className="mt-12 pt-8 border-t border-[#EEEDF6] font-serif text-[1.25rem] md:text-[1.45rem] leading-snug text-[#121A3A] flex flex-wrap gap-x-3 gap-y-1" data-id="element-6670" data-mp="3e2y9jsnpq3ky">
          {c.signature.map((s, i) => <span key={s.fr} className={i === c.signature.length - 1 ? 'text-[#4F46E5]' : ''} data-id="element-6671" data-mp="35189xzjofyc3" data-mpi={i}>{pick(s)}</span>)}
        </p>
      </motion.div>
    </section>;
}